import React from 'react';
import CrmInfoSection from './CrmInfoSection';
import CrmInfoRow from './CrmInfoRow';
import { Typography } from 'antd';
import { mdiAccount, mdiMapMarker } from '@mdi/js';
import { CountryFormatter } from '../formatters';

const { Text } = Typography;

const CrmPersonalInformation = ({ data, title }) => {
  return (
    <div>
      <CrmInfoSection title={title || 'Personal Information'} icon={mdiAccount}>
        <CrmInfoRow label='First Name'>
          <Text strong className='text-sm'>
            {data.first_name || '-'}
          </Text>
        </CrmInfoRow>
        <CrmInfoRow label='Middle Name'>
          <Text className='text-sm'>{data.middle_name || '-'}</Text>
        </CrmInfoRow>
        <CrmInfoRow label='Last Name'>
          <Text strong className='text-sm'>
            {data.last_name || '-'}
          </Text>
        </CrmInfoRow>
        <CrmInfoRow label='Gender'>
          <Text className='text-sm'>{data.gender || '-'}</Text>
        </CrmInfoRow>
        <CrmInfoRow label='Date of Birth'>
          <Text className='text-sm'>{data.date_of_birth || '-'}</Text>
        </CrmInfoRow>
        <CrmInfoRow label='Marital Status'>
          <Text className='text-sm'>{data.marital_status || '-'}</Text>
        </CrmInfoRow>
        <CrmInfoRow label='Personal Number'>
          <Text className='text-sm'>{data.personal_number || '-'}</Text>
        </CrmInfoRow>
      </CrmInfoSection>
      <CrmInfoSection title='Address' icon={mdiMapMarker}>
        <CrmInfoRow label='Country'>
          {data.country ? (
            <CountryFormatter value={data.country} editable={false} />
          ) : (
            <Text type='secondary'>-</Text>
          )}
        </CrmInfoRow>
        <CrmInfoRow label='State'>
          <Text strong className='text-sm'>
            {data.state || '-'}
          </Text>
        </CrmInfoRow>
        <CrmInfoRow label='City'>
          <Text strong className='text-sm'>
            {data.city || '-'}
          </Text>
        </CrmInfoRow>
        <CrmInfoRow label='Address 1'>
          <Text strong className='text-sm'>
            {data.address_1 || '-'}
          </Text>
        </CrmInfoRow>
        <CrmInfoRow label='Address 2'>
          <Text strong className='text-sm'>
            {data.address_2 || '-'}
          </Text>
        </CrmInfoRow>
        <CrmInfoRow label='Postal Code'>
          <Text strong className='text-sm'>
            {data.postal_code || '-'}
          </Text>
        </CrmInfoRow>
      </CrmInfoSection>
    </div>
  );
};

export default CrmPersonalInformation;
